/**
 * EditOpportunityModal Styles
 * Extracted per Cursor Rules (<300 lines per file)
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, touch } from '../../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.background,
  },
  
  // Header
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: space.md,
    paddingVertical: space.sm,
    borderBottomWidth: 1,
    borderBottomColor: color.border,
    backgroundColor: color.surface,
  },
  closeButton: {
    width: touch.minimum,
    height: touch.minimum,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerTitle: {
    fontSize: text.sectionTitle.fontSize,
    fontWeight: text.sectionTitle.fontWeight,
    color: color.textPrimary,
  },
  saveButton: {
    backgroundColor: color.primary,
    paddingHorizontal: space.lg,
    paddingVertical: space.sm,
    borderRadius: radius.md,
    minWidth: 70,
    alignItems: 'center',
  },
  saveButtonDisabled: {
    backgroundColor: color.disabled,
  },
  saveButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
  
  // Scroll
  scroll: {
    flex: 1,
  },
  scrollContent: {
    padding: space.md,
    gap: space.md,
  },
  
  // Error
  errorBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.sm,
    padding: space.md,
    backgroundColor: color.errorLight,
    borderRadius: radius.md,
  },
  errorText: {
    fontSize: text.body.fontSize,
    color: color.error,
    flex: 1,
  },
  
  // Fields
  field: {
    gap: space.xs,
  },
  label: {
    fontSize: text.caption.fontSize,
    fontWeight: '600',
    color: color.textSecondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  input: {
    backgroundColor: color.surface,
    borderWidth: 1,
    borderColor: color.border,
    borderRadius: radius.md,
    padding: space.md,
    fontSize: text.body.fontSize,
    color: color.textPrimary,
  },
  
  // Row layout
  row: {
    flexDirection: 'row',
    gap: space.md,
  },
  
  // Status grid
  statusGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: space.sm,
  },
  statusButton: {
    paddingHorizontal: space.md,
    paddingVertical: space.sm,
    backgroundColor: color.surface,
    borderWidth: 1,
    borderColor: color.border,
    borderRadius: radius.md,
  },
  statusButtonActive: {
    backgroundColor: color.primaryLight,
    borderColor: color.primary,
  },
  statusButtonText: {
    fontSize: text.caption.fontSize,
    color: color.textSecondary,
  },
  statusButtonTextActive: {
    color: color.primary,
    fontWeight: '600',
  },
});

